import React from 'react';
import staticUrls from '@finsight/urls/static';

import styles from '@/creditflowresearch/ui/components/bonds/common/BondTables/bondsTables.module.scss';

const TableFooterLabel = () => (
  <span className={ styles.helperLabel }>
    { 'Data accuracy and completeness are not warranted. Please review our ' }
    <a
      className={ styles.tableFooterLabel }
      href={ staticUrls.getTermsOfUseUrl() }
      target="_blank"
    >
      Terms
    </a>
    .
  </span>
);

export default TableFooterLabel;
